define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class OrderService
     */
    function OrderService(
        $rootScope,
        $q,
        $log,
        orderProvider,
        $indexedDB,
        clientService,
        localStorageService,
        $filter,
        commonService,
        offerService,
        orderTypeService
    ) {
        var self = this;
        var DIRTY_ORDERS_KEY = 'user.orders.dirtyOrders';
        var DIRTY_ORDERS_TO_SIGN_KEY = 'user.orders.dirtyOrdersToSign';
        var DIRTY_ORDERS_TO_DELETE_KEY = 'user.orders.dirtyOrdersToDelete';
        var DIRTY_ORDERS_TO_UPDATE_CPI_KEY = 'user.orders.dirtyOrdersToUpdateCPI';
        var DIRTY_ORDERS_TO_PUBLISH_CPI_KEY = 'user.orders.dirtyOrdersToPublishCPI';
        var DIRTY_ORDERS_TO_CANCEL_KEY = 'user.orders.dirtyOrderToCancel';
        var DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY = 'user.orders.dirtyOrderToCancelAndReplace';
        var DIRTY_ORDERS_TO_DUPLICATE_KEY = 'user.orders.dirtyOrderToDuplicate';
        var DIRTY_ORDERS_DUPLICATED_KEY = 'user.orders.dirtyDuplicatedOrder';
        var DIRTY_ORDERS_TO_LOSE_KEY = 'user.orders.dirtyOrdersToLose';
        var DIRTY_ORDERS_TO_ABANDONED_KEY = 'user.orders.dirtyOrdersToAbandoned';
        var DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY = 'user.orders.dirtyOrdersReadyForX3Integration';
        var DIRTY_ORDERS_REAL_DATE_SIGNATURE_KEY = 'user.orders.dirtyOrdersRealDateSignature';
        var DIRTY_ORDERS_CHANGE_CLIENT = 'user.orders.dirtyOrdersChangeClient';
        var MARKETS_WITHOUT_SCANUP_PRODUCT = ['LADDITION'];

        /**
         * Save the orders locally
         * @param  {Object} userNetwork
         */
        self.saveLocally = function saveLocally(orders) {
            for (var i = 0; i < orders.length; i++) {
                orders[i]._id = btoa(orders[i].dateCreated);
            }
            return $indexedDB.openStore('Orders', function(objectStore) {
                return objectStore.upsert(orders);
            });
        };

        /**
         * Get the locally orders
         * @return {Object}
         */
        function _getLocally(opts) {
            return $indexedDB.openStore('Orders', function(objectStore) {
                return objectStore.getAll().then(function(res) {
                    $log.info('GET local orders');
                    res.reverse();

                    if (opts.client) {
                        res = $filter('filter')(res, { $: opts.client });
                    }

                    if (opts.status !== null) {
                        if (opts.status) {
                            res = $filter('filter')(res, { isSigned: true, isCancelled: false });
                        }
                        else {
                            res = $filter('filter')(res, { isSigned: false });
                        }
                    }

                    if (opts.cancelled !== null) {
                        res = $filter('filter')(res, { isCancelled: !!opts.cancelled });
                    }

                    if (opts.lost !== null) {
                        res = $filter('filter')(res, { isLost: !!opts.lost });
                    }

                    return res.slice(opts.limit * opts.offset, opts.limit * (opts.offset + 1));
                });
            });
        }

        /**
         * Get a local order
         * @return {Object}
         */
        function _getLocalOrder(_id) {
            return $indexedDB.openStore('Orders', function(objectStore) {
                return objectStore.find(_id).then(function(res) {
                    return res;
                });
            });
        }

        /**
         * Get orders
         * @param  {object} opts
         * @return {Promise}
         */
        self.getOrders = function getOrders(opts) {
            if (!$rootScope.online) {
                return _getLocally(opts);
            }

            return orderProvider.getOrders(opts).then(function(orders) {
                // We have to synchronize the local orders with the webservice to avoid misunderstanding in the interface
                var dirtyOrders = _getDirtyOrders(DIRTY_ORDERS_KEY);
                var dirtyOrderToSign = _getDirtyOrders(DIRTY_ORDERS_TO_SIGN_KEY);
                var dirtyOrdersToUpdateCPI = _getDirtyOrders(DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
                var dirtyOrdersToPublishCPI = _getDirtyOrders(DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
                var dirtyOrderToCancel = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_KEY);
                var dirtyOrdersToCancelAndReplace = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);
                var dirtyOrdersToDuplicate = _getDirtyOrders(DIRTY_ORDERS_TO_DUPLICATE_KEY);
                var dirtyDuplicatedOrders = _getDirtyOrders(DIRTY_ORDERS_DUPLICATED_KEY);
                var dirtyOrdersToLose = _getDirtyOrders(DIRTY_ORDERS_TO_LOSE_KEY);
                var dirtyOrdersReadyForX3Integration = _getDirtyOrders(DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
                var dirtyOrdersChangeClient = _getDirtyOrders(DIRTY_ORDERS_CHANGE_CLIENT);
                var promise;
                var promises = [];
                var ordersToMerge = [];

                // Determine an array of unique order keys
                var uniqueKeys = dirtyOrders.concat(
                    dirtyOrderToSign.concat(dirtyOrdersToUpdateCPI.concat(dirtyOrdersToPublishCPI))
                );
                uniqueKeys = uniqueKeys.concat(
                    dirtyOrderToCancel.concat(dirtyOrdersToCancelAndReplace.concat(dirtyDuplicatedOrders))
                );
                uniqueKeys = uniqueKeys.concat(dirtyOrdersToLose.concat(dirtyOrdersReadyForX3Integration));
                for (var i = 0; i < uniqueKeys.length; ++i) {
                    for (var j = i + 1; j < uniqueKeys.length; ++j) {
                        if (uniqueKeys[i] === uniqueKeys[j]) {
                            uniqueKeys.splice(j--, 1);
                        }
                    }
                }

                // Determine if the webervice order has been modified in local to prefer the local version
                for (var i = orders.length - 1; i >= 0; i--) {
                    orders[i].isSynchronized = true;
                    for (var k = uniqueKeys.length - 1; k >= 0; k--) {
                        if (btoa(orders[i].dateCreated) === uniqueKeys[k]) {
                            orders.splice(i, 1);
                            promise = _getLocalOrder(uniqueKeys[k]).then(function(order) {
                                order.isSynchronized = false;
                                ordersToMerge.push(order);
                            });
                            uniqueKeys.splice(k, 1);
                            promises.push(promise);
                        }
                    }
                }

                // Add the local order
                for (var i = 0; i < uniqueKeys.length; i++) {
                    promise = _getLocalOrder(uniqueKeys[i]).then(function(order) {
                        ordersToMerge.push(order);
                    });
                    promises.push(promise);
                }

                return $q.all(promises).then(function() {
                    ordersToMerge = ordersToMerge.concat(orders);
                    return ordersToMerge;
                });
            });
        };

        /**
         * Get an empty order object
         * @return {Object}
         */
        self.getOrderObject = function getOrderObject() {
            return {
                id: null,
                business: null,
                bConnected: 'PAWEVER',
                RDSRef: null,
                DRVRef: null,
                orderType: orderTypeService.getOrderTypeByCode('TRAD'),
                drvBudget: null,
                client: {},
                clientContract: null,
                isAbandoned: false,
                isDeloitte: false,
                isMPDV: false,
                isSigned: false,
                isJdsInjected: false,
                isMultiStores: false,
                isScanupOwned: false,
                isExceptionalOffer: false,
                isFullPremiumOffer: false,
                isBgreenOffer: false,
                isQuickInstallOffer: false,
                isLost: false,
                dateLost: null,
                contract: {
                    nbTillsAdded: null,
                    nbMonths: 0,
                    nbMonthsFidelity: 0,
                    nbMonthsCalage: 0,
                    nbMonthsFranchise: 0,
                    monthlyPayment: 0,
                    monthlyPaymentFidelity: 0,
                    monthlyPaymentCalage: 0,
                    monthlyPaymentFranchise: 0,
                    previousInstallment: 0,
                    reconquest: false,
                    disposal: false,
                    scenarioType: {
                        id: null,
                        code: null,
                        label: null
                    },
                    isMudetaf: false,
                    isLaddition: false,
                    isScanupIncluded: false,
                    nbRenewals: 0,
                    contractType: {
                        id: null,
                        code: null,
                        label: null
                    }
                },
                tills: [],
                options: [],
                cashDrawers: [],
                goodwillGestures: null,
                prices: {
                    till: 0,
                    maintenanceTill: 0,
                    reintegration: 0,
                    printerRental: 0,
                    printerPurchase: 0,
                    scanup: 0,
                    scanupOptions: 0,
                    scanupBimediaPayDiscount: 0,
                    scanupBimediaPayOptions: 0,
                    flashup: 0,
                    tabletAndPC: 0,
                    tpe: 0,
                    insurance: 0,
                    tpeOptions: 0,
                    activateBBoosterOptions: 0,
                    BBoosterOptions: 0,
                    warrantyExtension: 0,
                    proforma: 0,
                    servicesNAP: 0,
                    sav: 0,
                    cashDrawers: 0,
                    tillAccessories: 0,
                    tillSoftware: 0,
                    softwareServices: 0,
                    packBoulangerie: 0,
                    gestion: 0,
                    prestationInstallation: 0,
                    promotions: []
                },
                dateSignature: null,
                dateInstallation: null,
                rdvOrigin: null,
                sponsor: {},
                comment: null,
                realDateSignature: null,
                replaceOrderId: null,
                promotions: [],
                unitBonus: {
                    hardAndSoft: 0,
                    maintenance: 0,
                    tpe: 0
                }
            };
        };

        /**
         * Get an empty goodwill gestures object
         * @return {Object}
         */
        self.getGoodwillGesturesObject = function getGoodwillGesturesObject() {
            return {
                revenue: {
                    rateId: null,
                    rateStartDateValidity: null,
                    rateEndDateValidity: null,
                    rateLabel: null,
                    rateValue: null,
                    typeCode: null,
                    typeLabel: null
                },
                mds: {
                    nbMDSRDS: 0,
                    nbMDSDRV: 0
                },
                moneyTransfer: {
                    enabled: false,
                    levelId: null,
                    clubBimedia: false
                },
                amount: {
                    mds: 0,
                    revenue: 0,
                    tillPartExchange: 0,
                    tpe: 0,
                    welcomeBonus: 0,
                    scanupPartExchange: 0,
                    scanupPartExchangeId: null,
                    tillPartExchangeId: null,
                    cashinServices: 0,
                    servicesFestival: 0,
                    launchBimediaPay: 0,
                    launchBBooster: 0,
                    moneyTransferServices: 0,
                    scanupServices: 0,
                    eagle: 0,
                    exceptionalOffer: 0,
                    fullPremiumOffer: 0,
                    bgreenOffer: 0,
                    quickInstall: 0,
                    clubBimedia: 0,
                    clubBimediaEncaissementMobile: 0
                },
                scanupServices: {
                    isUPS: false,
                    isBrinks: false
                },
                segment: {
                    segmentTypeId: null,
                    segmentCode: null,
                    segmentLabel: null
                },
                generosity: {
                    renunciationClubBimedia: false
                }
            };
        };

        /**
         * Get the corresponding list of orders keys to send to the webservice
         * @return {Array}
         */
        function _getDirtyOrders(key) {
            var dirtyOrders = localStorageService.get(key);
            return dirtyOrders ? JSON.parse(dirtyOrders) : [];
        }

        /**
         * Add an order key to the corresponding list of orders to send
         * @param {String} dateCreated
         */
        function _addDirtyOrder(dateCreated, key) {
            var dirtyOrders = _getDirtyOrders(key);
            var indexDirtyOrder = dirtyOrders.indexOf(btoa(dateCreated));

            if (indexDirtyOrder > -1) {
                return;
            }

            dirtyOrders.push(btoa(dateCreated));
            localStorageService.set(key, JSON.stringify(dirtyOrders));
        }

        /**
         * Add an order id to the corresponding list of orders to send
         * @param {String} dateCreated
         */
        function _addDirtyOrderToDelete(id) {
            if (!id) {
                return;
            }

            var dirtyOrders = _getDirtyOrders(DIRTY_ORDERS_TO_DELETE_KEY);

            dirtyOrders.push(id);
            localStorageService.set(DIRTY_ORDERS_TO_DELETE_KEY, JSON.stringify(dirtyOrders));
        }

        /**
         * Delete an order key from the corresponding list
         * @param  {String} dateCreated
         */
        function _deleteDirtyOrder(dateCreated, key) {
            var dirtyOrders = _getDirtyOrders(key);
            var indexDirtyOrder = dirtyOrders.indexOf(btoa(dateCreated));

            if (indexDirtyOrder === -1) {
                return;
            }

            dirtyOrders.splice(indexDirtyOrder, 1);
            localStorageService.set(key, JSON.stringify(dirtyOrders));
        }

        /**
         * Delete an order key from the corresponding list
         * @param  {String} dateCreated
         */
        function _deleteDirtyOrderDeleted(id) {
            var dirtyOrders = _getDirtyOrders(DIRTY_ORDERS_TO_DELETE_KEY);
            var indexDirtyOrder = dirtyOrders.indexOf(id);

            if (indexDirtyOrder === -1) {
                return;
            }

            dirtyOrders.splice(indexDirtyOrder, 1);
            localStorageService.set(DIRTY_ORDERS_TO_DELETE_KEY, JSON.stringify(dirtyOrders));
        }

        /**
         * Replace dirty order key in the corresponding list
         * @param  {String} oldDateCreated
         * @param  {String} newDateCreated
         * @param  {String} key
         */
        function _replaceDirtyOrder(oldDateCreated, newDateCreated, key) {
            var dirtyOrders = _getDirtyOrders(key);
            var indexDirtyOrder = dirtyOrders.indexOf(btoa(oldDateCreated));

            if (indexDirtyOrder === -1) {
                return;
            }

            dirtyOrders.splice(indexDirtyOrder, 1, btoa(newDateCreated));
            localStorageService.set(key, JSON.stringify(dirtyOrders));
        }

        /**
         * Save the order
         * @return {Promise}
         */
        self.saveOrder = function saveOrder(isGoodwillGestures, order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_KEY);

                if (!isGoodwillGestures) {
                    order.goodwillGestures = null;
                }

                // save locally the order
                return clientService.createUpdate(order.client).then(function(client) {
                    order.client = client;
                    return self.saveLocally([order]).then(function() {
                        return { order: order };
                    });
                });
            }

            // Send to the webservice
            return orderProvider
                .saveOrder(isGoodwillGestures, order)
                .then(function(res) {
                    // Update the local client
                    return self
                        .saveLocally([res.order])
                        .then(function() {
                            return res;
                        })
                        .then(function(res) {
                            // So if the order has been locally created offline and now the bdc is online, we are safe
                            return self.replaceDirtyOrders(res).then(function() {
                                return res;
                            });
                        });
                })
                .then(function(res) {
                    return clientService.saveLocally([res.order.client]).then(function() {
                        return res;
                    });
                });
        };

        self.replaceDirtyOrders = function replaceDirtyOrders(res) {
            return $q(function(resolve, reject) {
                // Delete the order key from the dirty orders list
                _deleteDirtyOrder(res.dateCreated, DIRTY_ORDERS_KEY);
                // Replace the order key if exists in dirtyOrderToSign
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_SIGN_KEY);
                // Replace the order key if exists in dirtyOrderToDelete
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_DELETE_KEY);
                // Replace the order key if exists in dirtTyOrdersToUpdateCPI
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
                // Replace the order key if exists in dirtTyOrdersToPublishCPI
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
                // Replace the order key if exists in dirtTyOrdersToCancel
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_CANCEL_KEY);
                // Replace the order key if exists in dirtTyOrdersToCancelAndReplace
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);
                // Replace the order key if exists in dirtTyOrdersToDuplicate
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_DUPLICATE_KEY);
                // Replace the order key if exists in dirtyOrdersToLose
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_TO_LOSE_KEY);
                // Replace the order key if exists in dirtyOrdersReadyForX3Integration
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
                // Replace the order key if exists in dirtyOrdersChangeClient
                _replaceDirtyOrder(res.dateCreated, res.order.dateCreated, DIRTY_ORDERS_CHANGE_CLIENT);
                resolve(res);
            }).then(function(res) {
                // If it's a new order, we delete the old one and insert the new one
                if (res.dateCreated !== res.order.dateCreated) {
                    return _deleteLocalOrder(res.dateCreated).then(function() {
                        return self.saveLocally([res.order]);
                    });
                }
                // We do nothing, the order has already been locally saved
                return;
            });
        };

        /**
         * Send the dirty orders (id === null)
         * @return {Promise}
         */
        self.sendDirtyOrders = function sendDirtyOrders() {
            var dirtyOrders = _getDirtyOrders(DIRTY_ORDERS_KEY);
            var dirtyDuplicatedOrders = _getDirtyOrders(DIRTY_ORDERS_DUPLICATED_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrders.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrders.length; i++) {
                // Pay attention : we can't send an order duplicated before the duplication action
                if (dirtyDuplicatedOrders.indexOf(dirtyOrders[i]) === -1) {
                    promise = _getLocalOrder(dirtyOrders[i]).then(function(order) {
                        return orderProvider.saveOrder(!!order.goodwillGestures, order).then(function(res) {
                            $log.info('The order ' + res.order.id + ' has been sended');
                            return self.replaceDirtyOrders(res);
                        });
                    });

                    promises.push(promise);
                }
            }

            return $q.all(promises);
        };

        /**
         * Delete a local order
         * @param  {String} dateCreated
         * @return {Promise}
         */
        function _deleteLocalOrder(dateCreated) {
            var _id = btoa(dateCreated);

            return $indexedDB.openStore('Orders', function(objectStore) {
                return objectStore.delete(_id);
            });
        }

        /**
         * Delete an order
         * We only can delete orders created in offline
         * @param {Object} order
         * @return {Promise}
         */
        self.deleteOrder = function deleteOrder(order) {
            if (!$rootScope.online) {
                if (order.id === null) {
                    _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_KEY);
                    return _deleteLocalOrder(order.dateCreated).then(function() {
                        return { message: 'Le bon de commande a été supprimé' };
                    });
                }

                return $q.reject({ message: 'Le bon de commande ne peut pas être supprimé. Raison : mode hors-ligne' });
            }

            return orderProvider.deleteOrder(order.id).then(function(res) {
                return res.info;
            });
        };

        /**
         * Change client an order
         * @param {Object} order
         * @param {Object} client
         * @return {Promise}
         */
        self.changeClient = function changeClient(order, client) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_CHANGE_CLIENT);
                // save locally the order
                order.client = client;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le bon de commande a été signé' };
                });
            }

            return orderProvider.changeClient(order.id, client).then(function(res) {
                order.client = client;
                return self.saveLocally([order]).then(function() {
                    return res.info;
                });
            });
        };

        self.sendDirtyOrdersChangeClient = function sendDirtyOrdersChangeClient() {
            var dirtyOrdersChangeClient = _getDirtyOrders(DIRTY_ORDERS_CHANGE_CLIENT);
            var promise;
            var promises = [];

            if (!dirtyOrdersChangeClient.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersChangeClient.length; i++) {
                promise = _getLocalOrder(dirtyOrdersChangeClient[i]).then(function(order, client) {
                    return orderProvider.changeClient(order.id, client).then(function(res) {
                        $log.info('La commande ' + order.id + ' a changé de client');
                        // Delete the sended order from the dirty orders ready for export list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_CHANGE_CLIENT);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Sign an order
         * @param {Object} order
         * @return {Promise}
         */
        self.signOrder = function signOrder(order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_SIGN_KEY);
                // save locally the order
                order.isSigned = true;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le bon de commande a été signé' };
                });
            }

            return orderProvider.signOrder(order.id, order).then(function(res) {
                order.isSigned = true;
                return self.saveLocally([order]).then(function() {
                    return res.info;
                });
            });
        };

        /**
         * Send dirty orders to sign to the webservice
         * @return {Promise}
         */
        self.sendDirtyOrdersToSign = function sendDirtyOrdersToSign() {
            var dirtyOrdersToSign = _getDirtyOrders(DIRTY_ORDERS_TO_SIGN_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToSign.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToSign.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToSign[i]).then(function(order) {
                    return orderProvider.signOrder(order.id, order).then(function(res) {
                        $log.info('The order ' + order.id + ' has been signed');
                        // Delete the sended order from the dirty orders to sign list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_SIGN_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Lose an order
         * @param  {Object} order
         * @return {Promise}
         */
        self.loseOrder = function loseOrder(order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_LOSE_KEY);
                // save locally the order
                order.isLost = true;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le bon de commande a été passé au statut perdu.' };
                });
            }

            return orderProvider.lose(order.id, order).then(function(res) {
                order.isLost = true;
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };

        /**
         * Send dirty orders to lose to the webservice
         * @return {Promise}
         */
        self.sendDirtyOrdersToLose = function sendDirtyOrdersToLose() {
            var dirtyOrdersToLose = _getDirtyOrders(DIRTY_ORDERS_TO_LOSE_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToLose.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToLose.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToLose[i]).then(function(order) {
                    return orderProvider.lose(order.id, order).then(function(res) {
                        $log.info('The order ' + order.id + ' has been set to lost status');
                        // Delete the sended order from the dirty orders to lose list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_LOSE_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Abandoned an order
         * @param  {Object} order
         * @return {Promise}
         */
        self.abandonedOrder = function (order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_ABANDONED_KEY);
                // save locally the order
                order.isAbandoned = true;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le devis a été passé au statut abandonné.' };
                });
            }

            return orderProvider.abandoned(order.id, order).then(function(res) {
                order.isAbandoned = true;
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };

        /**
         * Send dirty orders to lose to the webservice
         * @return {Promise}
         */
        self.sendDirtyOrdersToAbandoned = function () {
            var dirtyOrdersToAbandoned = _getDirtyOrders(DIRTY_ORDERS_TO_ABANDONED_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToAbandoned.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToAbandoned.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToAbandoned[i]).then(function(order) {
                    return orderProvider.abandoned(order.id, order).then(function(res) {
                        $log.info('The order ' + order.id + ' has been set to abandoned status');
                        // Delete the sended order from the dirty orders to lose list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_ABANDONED_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Set an order ready for X3 integration
         * @param  {Object} order
         * @return {Promise}
         */
        self.setOrderReadyForX3Integration = function setOrderReadyForX3Integration(order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
                // save locally the order
                order.isReadyForX3Integration = true;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le bon de commande a été passé au statut "Prêt pour intégration dans X3".' };
                });
            }

            return orderProvider.setReadyForX3Integration(order.id, order).then(function(res) {
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };

        /**
         * Send dirty orders ready for export to the webservice
         * @return {Promise}
         */
        self.sendDirtyOrdersReadyForX3Integration = function sendDirtyOrdersReadyForX3Integration() {
            var dirtyOrdersReadyForX3Integration = _getDirtyOrders(DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersReadyForX3Integration.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersReadyForX3Integration.length; i++) {
                promise = _getLocalOrder(dirtyOrdersReadyForX3Integration[i]).then(function(order) {
                    return orderProvider.setReadyForX3Integration(order.id, order).then(function(res) {
                        $log.info('The order ' + order.id + ' has been set to ready for X3 integration status');
                        // Delete the sended order from the dirty orders ready for export list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Send dirty orders real date signature to the webservice
         * @return {Promise}
         */
        self.sendDirtyOrdersRealDateSignature = function () {
            var dirtyOrdersRealDateSignature = _getDirtyOrders(DIRTY_ORDERS_REAL_DATE_SIGNATURE_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersRealDateSignature.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersRealDateSignature.length; i++) {
                promise = _getLocalOrder(dirtyOrdersRealDateSignature[i]).then(function(order) {
                    return orderProvider.setRealDateSignature(order.id, order).then(function(res) {
                        $log.info('The order ' + order.id + ' has been saved');
                        // Delete the sended order from the dirty orders ready for export list
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_REAL_DATE_SIGNATURE_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Set an order ready for X3 integration
         * @param  {Object} order
         * @return {Promise}
         */
        self.setRealDateSignature = function (order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_REAL_DATE_SIGNATURE_KEY);
                // save locally the order
                order.isReadyForX3Integration = true;
                return self.saveLocally([order]).then(function() {
                    return { message: 'Date de signature enregistrée".' };
                });
            }

            return orderProvider.setRealDateSignature(order.id, order).then(function(res) {
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };


        /**
         * Save a CPI
         * If offline, the order is locally saved to update or create the CPI later
         * @param  {Object} order
         * @return {Promise}
         */
        self.saveCPI = function saveCPI(order) {
            if(order.cpi.fai !== 'autre')
                order.cpi.autreFai = null;
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
                return self.saveLocally([order]).then(function() {
                    $log.info('Order with dateCreated : ' + order.dateCreated + ' has been locally saved');
                });
            }

            return orderProvider.saveCPI(order.id, order.cpi).then(function() {
                return self.saveLocally([order]);
            });
        };

        /**
         * Send dirty orders to update or create CPI
         * @return {Promise}
         */
        self.sendDirtyOrdersToUpdateCPI = function sendDirtyOrdersToUpdateCPI() {
            var dirtyOrdersToUpdateCPI = _getDirtyOrders(DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToUpdateCPI.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToUpdateCPI.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToUpdateCPI[i]).then(function(order) {
                    return orderProvider.saveCPI(order.id, order.cpi).then(function() {
                        $log.info('The cpi of the order ' + order.id + ' has been created or updated');
                        // Delete the sended order from the dirty orders to update CPI
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Delete a cpi for the correspong order
         * We only can delete a cpi created in offline
         * @param  {Object} order
         * @return {Promise}
         */
        self.deleteCPI = function deleteCPI(order) {
            if (!$rootScope.online) {
                if (order.id === null) {
                    return self.saveLocally([order]).then(function() {
                        return { message: 'Le CPI a été supprimé' };
                    });
                }

                return $q.reject({ data: { message: 'Le CPI ne peut pas être supprimé. Raison : mode hors-ligne' } });
            }

            order.cpi = null;
            return orderProvider.deleteCPI(order.id).then(function(res) {
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };

        /**
         * Publish a CPI
         * @param  {Object} order
         * @return {Promise}
         */
        self.publishCPI = function publishCPI(order) {
            order.cpi.isReleased = true;

            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le CPI a été publié' };
                });
            }

            return orderProvider.publishCPI(order.id).then(function(res) {
                return self.saveLocally([order]).then(function() {
                    return res;
                });
            });
        };

        /**
         * Send dirty orders to publish CPI
         * @return {Promise}
         */
        self.sendDirtyOrdersToPublishCPI = function sendDirtyOrdersToPublishCPI() {
            var dirtyOrdersToPublishCPI = _getDirtyOrders(DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToPublishCPI.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToPublishCPI.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToPublishCPI[i]).then(function(order) {
                    return orderProvider.publishCPI(order.id, order.cpi).then(function() {
                        $log.info('The cpi of the order ' + order.id + ' has been released');
                        // Delete the sended order from the dirty orders to publish CPI
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Cancel an order
         * @param  {Object} order
         * @return {Promise}
         */
        self.cancel = function cancel(order) {
            order.isCancelled = true;

            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_CANCEL_KEY);
                return self.saveLocally([order]).then(function() {
                    return { message: 'Le bon de commande a été annulé' };
                });
            }

            return orderProvider.cancel(order.id).then(function(res) {
                self.saveLocally([order]);
                return res;
            });
        };

        /**
         * Send dirty orders to cancel
         * @return {Promise}
         */
        self.sendDirtyOrdersToCancel = function sendDirtyOrdersToCancel() {
            var dirtyOrdersToCancel = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToCancel.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToCancel.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToCancel[i]).then(function(order) {
                    return orderProvider.cancel(order.id).then(function() {
                        $log.info('The order ' + order.id + ' has been cancelled');
                        // Delete the sended order from the dirty orders
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_CANCEL_KEY);
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Replace an order
         * @param  {Object} order
         * @return {Promise}
         */
        self.replace = function replace(order) {
            order.isCancelled = true;

            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);

                var dateCreated = moment().toISOString();
                order.replacedBy = btoa(dateCreated);

                return self.saveLocally([order]).then(function() {
                    var duplicatedOrder = JSON.parse(JSON.stringify(order)); // make a clone without object ref
                    duplicatedOrder.dateCreated = dateCreated;
                    duplicatedOrder.replacedBy = null;
                    duplicatedOrder.isCancelled = false;
                    duplicatedOrder.isSigned = false;
                    duplicatedOrder.cpi = order.cpi;
                    duplicatedOrder.business = order.business;
                    duplicatedOrder.replaceOrderId = order.id;
                    duplicatedOrder.idElectronicSignature = null;
                    duplicatedOrder.dateSendElectronicSignature = null;

                    duplicatedOrder.options = duplicatedOrder.options.reduce(function(acc, option) {
                        if(option.optionType.code !== 'GESTION' && option.optionType.code !== 'PRESTATION' && option.code.indexOf('INSTALLATION') !== -1 ) {
                            console.log(option);
                            acc.push(option);
                        }
                        return acc;
                    }, []);

                    return self.saveLocally([duplicatedOrder]).then(function() {
                        _addDirtyOrder(dateCreated, DIRTY_ORDERS_DUPLICATED_KEY);
                        return duplicatedOrder;
                    });
                });
            }

            return orderProvider.replace(order).then(function(res) {
                if (res.cpi !== null) {
                    self.saveCPI(res);
                }
                order.replacedBy = res.id;
                self.saveLocally([order, res]);
                return res;
            });
        };

        /**
         * Send dirty orders to cancel and replace
         * @return {Promise}
         */
        self.sendDirtyOrdersToCancelAndReplace = function sendDirtyOrdersToCancelAndReplace() {
            var dirtyOrdersToCancelAndReplace = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToCancelAndReplace.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToCancelAndReplace.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToCancelAndReplace[i]).then(function(order) {
                    return orderProvider.replace(order).then(function(duplicatedOrder) {
                        $log.info(
                            'The order ' +
                                order.id +
                                ' has been cancelled and replaced by the order : ' +
                                duplicatedOrder.id
                        );
                        // Delete the sended order from the dirty orders
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);

                        return _getLocalOrder(order.replacedBy).then(function(localDuplicatedOrder) {
                            localDuplicatedOrder.id = duplicatedOrder.id;

                            // Case when the order has been updated in offline after the cancel and replace action
                            return self
                                .saveOrder(!!localDuplicatedOrder.goodwillGestures, localDuplicatedOrder)
                                .then(function() {
                                    _deleteDirtyOrder(localDuplicatedOrder.dateCreated, DIRTY_ORDERS_DUPLICATED_KEY);
                                });
                        });
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Rollback the creation date of an order.
         * This function calls the `rollbackCreatedDate` method from the `orderProvider` service
         * to revert the creation date of the specified order.
         *
         * @function rollbackCreatedDate
         * @param {Object} order - The order object whose creation date needs to be rolled back.
         * @return {Promise} - A promise that resolves with the response from the `orderProvider`.
         */
        self.rollbackDateCreated = function(order) {
            return orderProvider.rollbackDateCreated(order).then(function(res) {
                return res;
            })
        }

        /**
         * Duplicate an order
         * @param  {Object} order
         * @return {Promise}
         */
        self.duplicate = function duplicate(order) {
            if (!$rootScope.online) {
                _addDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_DUPLICATE_KEY);

                var dateCreated = moment().toISOString();
                order.duplicateAs = btoa(dateCreated);

                return self.saveLocally([order]).then(function() {
                    var duplicatedOrder = JSON.parse(JSON.stringify(order)); // make a clone without object ref
                    duplicatedOrder.dateCreated = dateCreated;
                    duplicatedOrder.duplicateAs = null;
                    duplicatedOrder.isCancelled = false;
                    duplicatedOrder.isSigned = false;
                    duplicatedOrder.cpi = null;
                    return self.saveLocally([duplicatedOrder]).then(function() {
                        _addDirtyOrder(dateCreated, DIRTY_ORDERS_DUPLICATED_KEY);
                        return duplicatedOrder;
                    });
                });
            }

            return orderProvider.duplicate(order).then(function(res) {
                order.duplicateAs = res.id;
                self.saveLocally([order, res]);
                return res;
            });
        };

        /**
         * Send dirty orders to duplicate
         * @return {Promise}
         */
        self.sendDirtyOrdersToDuplicate = function sendDirtyOrdersToDuplicate() {
            var dirtyOrdersToDuplicate = _getDirtyOrders(DIRTY_ORDERS_TO_DUPLICATE_KEY);
            var promise;
            var promises = [];

            if (!dirtyOrdersToDuplicate.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyOrdersToDuplicate.length; i++) {
                promise = _getLocalOrder(dirtyOrdersToDuplicate[i]).then(function(order) {
                    return orderProvider.duplicate(order).then(function(duplicatedOrder) {
                        $log.info('The order ' + order.id + ' has been duplicated as the order: ' + duplicatedOrder.id);
                        // Delete the sended order from the dirty orders
                        _deleteDirtyOrder(order.dateCreated, DIRTY_ORDERS_TO_DUPLICATE_KEY);

                        return _getLocalOrder(order.duplicateAs).then(function(localDuplicatedOrder) {
                            localDuplicatedOrder.id = duplicatedOrder.id;
                            // Case when the order has been updated in offline after the duplicate action (lost connection in between)
                            return self
                                .saveOrder(!!localDuplicatedOrder.goodwillGestures, localDuplicatedOrder)
                                .then(function() {
                                    _deleteDirtyOrder(localDuplicatedOrder.dateCreated, DIRTY_ORDERS_DUPLICATED_KEY);
                                });
                        });
                    });
                });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Save cmde keys
         * Only online
         * @return {Promise}
         */
        self.saveCmdeKeys = orderProvider.saveCmdeKeys;

        /**
         * set isJdsInjected
         * Only online
         * @return {Promise}
         */
        self.setJdsInjected = orderProvider.setJdsInjected;

        /**
         * Find which till type is present in the order and return isMixed boolean.
         * @method areTillsMixed
         * @param  {Array}      tills Array with all tills of the order
         * @return {Object}     tillType as a String + isMixed boolean to define if the order has more than one till type
         */
        self.areTillsMixed = function areTillsMixed(tills) {
            var sameTillType;
            var tillsTypeArray = (tills || [])
                .filter(function(till) {
                    return till.nbTills > 0;
                })
                .map(function(till) {
                    return till.tillType.code;
                });
            if (tillsTypeArray.length !== 0) {
                sameTillType = tillsTypeArray.reduce(function(type1, type2) {
                    return type1 === type2 ? type1 : null;
                });
            }

            return {
                isMixed: !sameTillType,
                tillType: sameTillType
            };
        };

        /**
         * Count the number of tills from the tills array
         * @param  {Array} tills array
         * @return {Number}
         */
        self.getNbTills = function getNbTills(tills) {
            return tills
                .map(function(till) {
                    return till.nbTills;
                })
                .reduce(function(previous, current) {
                    return previous + current;
                }, 0);
        };

        /**
         * Count the number of tills from the tills array without maintenance package
         * @param  {Array} tills array
         * @return {Number}
         */
        self.getNbTillsWithoutMaintenancePackage = function (tills) {
            return tills
                .reduce(function(curr, next) {
                    if(['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(next.tillType.code) === -1)
                        curr.push(next.nbTills);
                    return curr;
                },[])
                .reduce(function(previous, current) {
                    return previous + current;
                }, 0);
        };

        /**
         * Get nb tills by till type
         * @param  {Array} tills array
         * @return {Object} On key for each tillType found in the array
         *  {'tillType': number of tills, ...}
         */
        self.getNbTillsByTillType = function getNbTillsByTillType(tills) {
            var nbTills = {};
            tills.forEach(function(till) {
                if (till.tillType.code in nbTills) {
                    nbTills[till.tillType.code] += till.nbTills;
                }
                else {
                    nbTills[till.tillType.code] = till.nbTills;
                }
            });
            return nbTills;
        };

        /**
         * Count the number of cashdrawers from the cashdrawers array
         * @param  {Array} cashdrawers array
         * @return {Number}
         */
        self.getNbCashDrawers = function getNbCashDrawers(cashdrawers) {
            return cashdrawers
                .map(function(cashdrawer) {
                    return cashdrawer.nbCashDrawers;
                })
                .reduce(function(previous, current) {
                    return previous + current;
                }, 0);
        };

        /* =========================================================================================== */
        /*                                         CONTRACT                                            */
        /* =========================================================================================== */

        self.getContractMonths = function getContractMonths(order) {
            return order.contract.contractType.code === 'LOC48'
                ? 48
                : order.contract.contractType.code === 'LOC60'
                    ? 60
                    : order.contract.contractType.code === 'LOC36'
                        ? 36
                        : order.contract.contractType.code === 'LOC24'
                            ? 24
                            : 48;
        };

        /**
         * Get amount of months SAV
         * @param  {Object} order
         * @return {Number}
         */
        self.getSAVMonths = function getSAVMonths(order) {
            if (
                self.areTillsMixed(order.tills).tillType !== undefined &&
                self.areTillsMixed(order.tills).tillType !== null
            ) {
                return self.areTillsMixed(order.tills).tillType.code === 'BT+' ? self.getContractMonths(order) : 36;
            }
            else {
                return 36;
            }
        };

        /**
         * Returns boolean given an order's contract type
         * @param  {String}  contract type 'LOC36' 'LOC48' 'LOC60' or 'ACHAT'
         * @return {Boolean}
         */
        self.isRental = function isRental(type) {
            return type !== 'ACHAT';
        };

        /* =========================================================================================== */
        /*                                         DISCOUNT                                            */
        /* =========================================================================================== */

        /**
         * Get the discount value stored in the orderDiscounts rootscope
         * @param  {Object} option
         * @return Number
         */
        self.getDiscountValue = function getDiscountValue(option) {
            var discountObject = $rootScope.orderDiscounts.find(function(discount) {
                return discount.id === option.id;
            });
            return discountObject ? discountObject.value : 0;
        };

        /**
         * Update all discount values in the rootscope
         * @param  {Array} options array containing options object
         * @return {Array} discounts objects in the array: {id: option_id, value: discount(between 0 and 100)}
         */
        self.updateDiscountValues = function updateDiscountValues(options) {
            var discounts = options.map(function(option) {
                return { id: option.id, value: option.discount };
            });
            return discounts;
        };

        /**
         * Check if there is a discount above the limited rate in the order
         * @param  {Array} options
         * @return {Array} Options with a discount above the limit
         */
        self.checkDiscounts = function checkDiscounts(options) {
            return options.filter(function(option) {
                return (
                    option.discount > goodwillGesturesService.ALLOWED_DISCOUNT_RATE && self.discountPermission(option)
                );
            });
        };

        /**
         * Does an option need an permission to be discounted above a certain rate or not ?
         * @param  {Object} option
         * @return {Boolean}
         */
        self.discountPermission = function discountPermission(option) {
            return (
                option.optionType.code === 'MAINTENANCE' ||
                option.optionType.code === 'SAV' ||
                (option.optionType.code === 'TPE' && option.isTPEDevice)
            );
        };

        /* =========================================================================================== */
        /*                                         Sponsor                                             */
        /* =========================================================================================== */

        /**
         * Get all relevant sponsor infos (ie different from null)
         * @param  {Object} sponsor
         * @return {Array} sponsor values
         */
        self.getSponsorInfos = function getSponsorInfos(sponsor) {
            return Object.keys(sponsor)
                .filter(function(key) {
                    return sponsor[key] !== null && key !== 'gift';
                })
                .map(function(key) {
                    return sponsor[key];
                });
        };

        self.getJdpOrders = function(startDate, endDate) {
            return orderProvider.getJdpOrders(startDate, endDate).then(function(res) {
                return res;
            });
        }

        self.saveSponsor = (data) => {
            return orderProvider.saveSponsor(data).then(function(res) {
                return res;
            });
        }

        /* =========================================================================================== */
        /*                                         Options                                             */
        /* =========================================================================================== */

        /**
         * Check if a given optionType option is present in a given option Array
         * @param  {Array}  options
         * @param  {String}  type    OptionType to check
         * @return {Boolean}
         */
        self.isThereOptionType = function isThereOptionType(options, type) {
            return (
                (
                    options.filter(function(option) {
                        return option.optionType.code === type;
                    }) || []
                ).length > 0
            );
        };

        /**
         * Filter prices array for a given option according to prices isValid attribute
         * @param tillPrices
         * @param  {Object} order
         * @return {Array} filtered prices array
         */
        self.filterTillPrices = function (tillPrices, order) {
            return tillPrices.prices.filter(function(priceToFilter) {
                return commonService.isInDateRange(
                    order.dateCreated,
                    priceToFilter.minDateValidity,
                    priceToFilter.maxDateValidity
                );
            });
        };

        self.isValidPrice = function(price, dateCreated){
            return commonService.isInDateRange(
                dateCreated,
                price.minDateValidity,
                price.maxDateValidity
            );
        };

        /**
         * Filter prices array for a given option according to prices isValid attribute
         * @param  {Object}  option
         * @param  {Object} order
         * @return {Array} filtered prices array
         */
        self.filterOptionPrices = function filterOptionPrices(option, order) {
            return option.prices.filter(function(priceToFilter) {
                return commonService.isInDateRange(
                    order.dateCreated,
                    priceToFilter.minDateValidity,
                    priceToFilter.maxDateValidity
                );
            });
        };

        /**
         * Filter the insurances prices with the given network
         * @param {Array} prices
         * @param {Object} order
         * @param {String} network
         */
        self.filterInsuranceValidPricesByOrder = function(prices, order) {
            return prices.filter(function(priceToFilter) {
                return (
                    commonService.isInDateRange(
                        order.dateCreated,
                        priceToFilter.minDateValidity,
                        priceToFilter.maxDateValidity
                    ) && priceToFilter.orderType.code === order.orderType.code
                );
            });
        };

        /**
         * Format each insurance line to add the prices used in the report
         * @param {Array] prices
         * @param {Object} order
         * @returns {Array} filteredPrices
         */
        self.formatInsurancePricesForReport = function(prices, order) {
            var filteredPrices = self.filterInsuranceValidPricesByOrder(prices, order);
            var nbTills = self.getNbTills(order.tills);
            let nbTillsWithout

            for (var i = 0; i < filteredPrices.length; i++) {
                var price = filteredPrices[i];

                price.totalPriceHT = price.value * nbTills;
                price.totalPriceTTC = price.totalPriceHT * (1 + parseFloat(price.tva));

                // In the database the tva is stored in the format : 0.2 for 20%
                // We need to display '20 %' in the report
                price.tvaDisplay = price.tva * 100;
            }

            return filteredPrices;
        };

        /**
         * Check if there is a scanupDevice in a given options array
         * @param  {Array}  options
         * @return {Boolean}
         */
        self.isScanupDevicePresent = function isScanupDevicePresent(options) {
            return (
                (
                    options.filter(function(option) {
                        return option.isScanupDevice;
                    }) || []
                ).length > 0
            );
        };

        self.isScanupSelected = function isScanupSelected(options) {
            return (
                (
                    options.filter(function(option) {
                        return (option.optionType.code === 'SCANUP' || option.isScanupDevice) && option.nbOptions > 0;
                    }) || []
                ).length > 0
            );
        };

        /**
         * Check if a given option is the mandatory wifiRepeater option
         * @param  {Object}  option
         * @param  {String}  type   orderType
         * @return {Boolean}
         */
        self.isMandatoryWifiRepeater = function isMandatoryWifiRepeater(option, type) {
            var id;
            // set the wifi repeater id
            // TODO: Use codes instead of ids
            switch (type) {
                case 'NAP':
                    id = 130;
                    break;
                case 'FLORAJET':
                    id = 227;
                    break;
                default:
                    id = 129;
            }

            return option.id === id;
        };

        /**
         * Check if a given option is a scanup software
         * @param  {Object}  option
         * @param  {String}  type   orderType
         * @return {Boolean}
         */
        self.isScanupSoftware = function(option, type) {
            if (type === 'TRAD') {
                var ids = [131, 132, 133, 228];
                return ids.indexOf(option.id) !== -1;
            }

            return false;
        };

        /**
         * Check if a given option is the mandatory install on site option
         * @param  {Object}  option
         * @param  {String}  type   orderType
         * @return {Boolean}
         */
        self.isMandatoryScanupInstall = function (option, type) {
            return option.code === 'INSTALLATION-SCANUP-SITE';
        };

        /**
         * Pourune commande donnée, retourne les ids des logiciels Scan'Up qu'il est possible de commander
         * @param {Object} order
         * @returns {Array}
         */
        self.getAuthorizedScanupSoftwareIds = function(order) {
            var tobaccoScanupSoftwareId = 131;
            var pressScanupSoftwareId = 132;
            var tobaccoAndPressScanupSoftwareId = 133;
            let productScanupSoftwareId = 228

            if (order.tills.length === 0) {
                return [tobaccoScanupSoftwareId, pressScanupSoftwareId, tobaccoAndPressScanupSoftwareId, productScanupSoftwareId];
            }

            var tobaccoSoftwareId = 54;
            var pressSoftwareId = 55;
            let cartSoftwareId = 120;
            var hasTobaccoSoftware = false;
            var hasPressSoftware = false;
            let hasCartSoftware = false;

            order.options.forEach(function(option) {
                if (option.id === tobaccoSoftwareId) {
                    hasTobaccoSoftware = true;
                }
                else if (option.id === pressSoftwareId) {
                    hasPressSoftware = true;
                } else if (option.id === cartSoftwareId) {
                    hasCartSoftware = true
                }
            });

            if (hasPressSoftware && hasTobaccoSoftware || (hasTobaccoSoftware && hasPressSoftware && hasCartSoftware)) {
                return [tobaccoAndPressScanupSoftwareId];
            }
            else if (hasTobaccoSoftware || (hasTobaccoSoftware && hasCartSoftware)) {
                return [tobaccoScanupSoftwareId];
            }
            else if (hasPressSoftware || (hasPressSoftware && hasCartSoftware)) {
                return [pressScanupSoftwareId];
            }
            else if (hasCartSoftware){
                return [productScanupSoftwareId];
            }
            else {
                return [];
            }
        };

        /**
         * Pour une commande donnée, retourne l'éventuelle option "Logiciel Scan'Up" selectionnée
         * @param {Object} order
         * @returns {Object|null}
         */
        self.getSelectedScanupSoftwareOption = function(order) {
            for (var i = 0; i < order.options.length; i++) {
                if (self.isScanupSoftware(order.options[i], order.orderType.code)) {
                    return order.options[i];
                }
            }

            return null;
        };

        /**
         * Comparator function used in map, reduce or filters on any option attribute
         * @param  {String} key key to evaluate
         * @param           value type or value to check
         * @return {function}      Return comparator function to check
         */
        self.checkOptionKey = function checkOptionKey(key, value) {
            return function(option) {
                return option[key] === value;
            };
        };

        /* =========================================================================================== */
        /*                                         ORDERS local cache                                  */
        /* =========================================================================================== */

        self.clearCache = function clearCache() {
            localStorageService.set(DIRTY_ORDERS_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_SIGN_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_DELETE_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_UPDATE_CPI_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_PUBLISH_CPI_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_CANCEL_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_DUPLICATE_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_DUPLICATED_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_TO_LOSE_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_ORDERS_CHANGE_CLIENT, JSON.stringify([]));

            return $indexedDB.openStore('Orders', function(objectStore) {
                return objectStore.clear();
            });
        };

        self.downloadOrders = function downloadOrders() {
            if ($rootScope.online) {
                return self.clearCache().then(function() {
                    var opts = {
                        rds: [$rootScope.user.uid],
                        drv: [],
                        telepro: [],
                        cup: [],
                        formerRDS: [],
                        market: [],
                        limit: 150,
                        offset: 0,
                        dateStart: moment()
                            .subtract(1, 'year')
                            .format('YYYY-MM-DD'),
                        dateEnd: moment().format('YYYY-MM-DD'),
                        creationDateStart: moment()
                            .subtract(1, 'year')
                            .format('YYYY-MM-DD'),
                        creationDateEnd: moment().format('YYYY-MM-DD'),
                        signatureMonth: [],
                        installationMonth: [],
                        status: null,
                        cancelled: null,
                        cpiNotCreated: null,
                        cpiReleased: null,
                        jdsInjected: null,
                        cmdeKey: null,
                        orderScenario: []
                    };
                    return orderProvider.getOrders(opts).then(function(orders) {
                        self.saveLocally(orders);
                    });
                });
            }

            return $q.reject();
        };

        /**
         * Determine if there are some orders to send to the webservice
         * @return {Boolean}
         */
        self.isSomethingToSynchronize = function isSomethingToSynchronize() {
            var dirtyOrders = _getDirtyOrders(DIRTY_ORDERS_KEY);
            if (dirtyOrders.length) {
                return true;
            }

            var dirtyOrdersToSign = _getDirtyOrders(DIRTY_ORDERS_TO_SIGN_KEY);
            if (dirtyOrdersToSign.length) {
                return true;
            }

            var dirtyOrdersToUpdateCPI = _getDirtyOrders(DIRTY_ORDERS_TO_UPDATE_CPI_KEY);
            if (dirtyOrdersToUpdateCPI.length) {
                return true;
            }

            var dirtyOrdersToPublishCPI = _getDirtyOrders(DIRTY_ORDERS_TO_PUBLISH_CPI_KEY);
            if (dirtyOrdersToPublishCPI.length) {
                return true;
            }

            var dirtyOrdersToCancel = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_KEY);
            if (dirtyOrdersToCancel.length) {
                return true;
            }

            var dirtyOrdersToCancelAndReplace = _getDirtyOrders(DIRTY_ORDERS_TO_CANCEL_AND_REPLACE_KEY);
            if (dirtyOrdersToCancelAndReplace.length) {
                return true;
            }

            var dirtyOrdersToDuplicate = _getDirtyOrders(DIRTY_ORDERS_TO_DUPLICATE_KEY);
            if (dirtyOrdersToDuplicate.length) {
                return true;
            }

            var dirtyOrdersToLose = _getDirtyOrders(DIRTY_ORDERS_TO_LOSE_KEY);
            if (dirtyOrdersToLose.length) {
                return true;
            }

            var dirtyOrdersReadyForX3Integration = _getDirtyOrders(DIRTY_ORDERS_READY_FOR_X3_INTEGRATION_KEY);
            if (dirtyOrdersReadyForX3Integration.length) {
                return true;
            }

            var dirtyOrdersChangeClient = _getDirtyOrders(DIRTY_ORDERS_CHANGE_CLIENT);
            if (dirtyOrdersChangeClient.length) {
                return true;
            }

            var dirtyOrdersChangeClient = _getDirtyOrders(DIRTY_ORDERS_CHANGE_CLIENT);
            if (dirtyOrdersChangeClient.length) {
                return true;
            }

            var dirtyDuplicatedOrders = _getDirtyOrders(DIRTY_ORDERS_DUPLICATED_KEY);
            return dirtyDuplicatedOrders.length;
        };

        self.isScanUpProductAllowed = function isScanUpProductAllowed(order) {
            return MARKETS_WITHOUT_SCANUP_PRODUCT.indexOf(order.marketType.code) === -1;
        };

        /**
         * Envoi les données de la commande pour la signature electronique
         * Only online
         * @return {Promise}
         */
        self.electronicSignature = orderProvider.electronicSignature;

        self.getEsignUrl = (registration) => {
            return orderProvider.getEsignUrl(registration);
        }

        self.getDocuments = (registration) => {
            return orderProvider.getDocuments(registration);
        }

        /**
         * Save the reference of the order returned by the signature API
         * Only online
         * @return {Promise}
         */
        self.saveSignApiReference = orderProvider.saveSignApiReference;

        return self;
    }

    OrderService.$inject = [
        '$rootScope',
        '$q',
        '$log',
        'order',
        '$indexedDB',
        'clientService',
        'localStorageService',
        '$filter',
        'commonService',
        'offerService',
        'orderTypeService'
    ];

    angular.module('app.bdc.list.orderService', []).factory('orderService', OrderService);
});
